export enum IBreakpoint {
  XXL = 1400,
  XL = 1200,
  LG = 992,
  MD = 768,
  SM = 576,
  XS = 500,
}
